import { FieldType } from "../api.js";
import { BaseModelConvertSpec } from "./base.specs.js";
const FundingMethodConvertSpec = {
  ...BaseModelConvertSpec,
  min: FieldType.BigNumber,
  max: FieldType.BigNumber
};
export {
  FundingMethodConvertSpec
};
